import { render, staticRenderFns } from "./UpgradeVip.vue?vue&type=template&id=6272c87a&scoped=true"
import script from "./UpgradeVip.vue?vue&type=script&lang=js"
export * from "./UpgradeVip.vue?vue&type=script&lang=js"
import style0 from "./UpgradeVip.vue?vue&type=style&index=0&id=6272c87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6272c87a",
  null
  
)

export default component.exports